import { LinearProgress, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { Flex } from '../../../../base/components/Flex';
import { useTranslationPrefix } from '../../../../hooks/useTranslationPrefix';
import QrPageLogo from '../components/QrPageLogo';

interface Props {
  seconds: number;
  onNext: () => void;
}

const QrWaitStep = ({ seconds, onNext }: Props) => {
  const { _t } = useTranslationPrefix('LaunchPlaylistQrPageNew');

  const [waitState, setWaitState] = useState<{
    remaining: number;
    progress: number;
  }>({
    progress: 0,
    remaining: seconds,
  });

  const pastDue = waitState.remaining <= 0;
  useEffect(() => {
    const nextAt = seconds * 1000 + Date.now();
    const interval = setInterval(() => {
      const remaining = nextAt - Date.now();
      setWaitState({
        remaining: Math.max(0, Math.ceil(remaining / 1000)),
        progress: Math.max(0, Math.min(1, 1 - remaining / (seconds * 1000))),
      });
    }, 50);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (pastDue) {
      onNext();
    }
  }, [pastDue]);

  return (
    <Flex
      flexDirection="column"
      width="100%"
      minHeight="100%"
      alignItems="center"
      gap={2}
      px={{ xs: 2, md: 6 }}
    >
      <Flex
        flexDirection="column"
        width="100%"
        alignItems={{ xs: 'center', md: 'end' }}
      >
        <QrPageLogo />
      </Flex>
      <Flex
        flexDirection="column"
        alignItems="center"
        gap={{ xs: 4, md: 6 }}
        my="auto"
      >
        <Typography
          fontSize={{ xs: '2.25rem', md: '3rem' }}
          lineHeight="normal"
          fontWeight="300"
          textAlign="center"
        >
          {_t('putHeadsetOnIn', 'Put headset on in')}
        </Typography>
        <LinearProgress
          variant="determinate"
          color="success"
          value={waitState.progress * 100}
          sx={{ height: 8, width: '100%' }}
        />
        <Typography
          fontSize={{ xs: '2rem', md: '3rem' }}
          lineHeight="normal"
          fontWeight="300"
          textAlign="center"
        >
          <strong>{waitState.remaining}</strong> {_t('seconds', 's')}
        </Typography>
      </Flex>
    </Flex>
  );
};

export default QrWaitStep;
